export default {"src":"/frontend-static/_next/static/media/appStoreEn.bbfeaae5.svg","height":40,"width":120,"blurWidth":0,"blurHeight":0};